export function shouldShowCapacity(resource) {
    return resource?.capacity > 1 || resource?.type !== 'Person';
}

export function getBookWithLabel(resources, defaultLabel) {
    let label = '';
    for (const resource of resources) {
        if (!label) {
            label = resource.type;
        } else if (label !== resource.type) {
            if (typeof defaultLabel === 'undefined') {
                return 'Book With';
            } else {
                return defaultLabel;
            }
        }
    }

    // They are all the same!
    return label;
}
